import React from 'react';
import { FileTextIcon, DownloadIcon, SearchIcon, BookmarkIcon, BellIcon } from 'lucide-react';
export function RecentActivity() {
  const activities = [{
    id: 1,
    type: 'search',
    description: 'Vous avez effectué une recherche pour "Projets d\'infrastructure au Maroc"',
    time: 'Il y a 2 heures',
    icon: SearchIcon,
    iconColor: 'bg-blue-100 text-blue-600'
  }, {
    id: 2,
    type: 'view',
    description: "Vous avez consulté l'appel d'offres \"Construction d'un centre hospitalier à Dakar\"",
    time: 'Il y a 3 heures',
    icon: FileTextIcon,
    iconColor: 'bg-green-100 text-green-600'
  }, {
    id: 3,
    type: 'download',
    description: 'Vous avez téléchargé le cahier des charges pour "Fourniture d\'équipements informatiques pour écoles"',
    time: 'Il y a 5 heures',
    icon: DownloadIcon,
    iconColor: 'bg-purple-100 text-purple-600'
  }, {
    id: 4,
    type: 'bookmark',
    description: 'Vous avez ajouté "Installation de panneaux solaires pour zones rurales" à vos favoris',
    time: 'Il y a 1 jour',
    icon: BookmarkIcon,
    iconColor: 'bg-yellow-100 text-yellow-600'
  }, {
    id: 5,
    type: 'alert',
    description: 'Vous avez créé une alerte pour "Projets agricoles en Côte d\'Ivoire"',
    time: 'Il y a 2 jours',
    icon: BellIcon,
    iconColor: 'bg-red-100 text-red-600'
  }];
  return <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-227">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-228">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-229">
          Activité récente
        </h2>
      </div>
      <div className="px-6 py-4" data-id="element-230">
        <ul className="space-y-6" data-id="element-231">
          {activities.map(activity => <li key={activity.id} className="relative" data-id="element-232">
              <div className="relative flex space-x-3" data-id="element-233">
                <div data-id="element-234">
                  <span className={`h-8 w-8 rounded-full flex items-center justify-center ${activity.iconColor}`} data-id="element-235">
                    <activity.icon className="h-5 w-5" data-id="element-236" />
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 justify-between space-x-4" data-id="element-237">
                  <div data-id="element-238">
                    <p className="text-sm text-gray-700" data-id="element-239">
                      {activity.description}
                    </p>
                  </div>
                  <div className="whitespace-nowrap text-right text-sm text-gray-500" data-id="element-240">
                    <time data-id="element-241">{activity.time}</time>
                  </div>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
      <div className="px-6 py-4 border-t border-gray-200 text-center" data-id="element-242">
        <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-800" data-id="element-243">
          Voir toutes les activités
        </a>
      </div>
    </div>;
}